import * as uuid from "uuid";
import Movable from "../workspace/mixin/movable";
import EventManager from "../../store/sqftEventManager";
import ModelCorePoint from "../workspace/textBox/model/modelCorePoint";
import workspace from "../workspace";
import {getPointField} from "../../../../helpers/sqftHelper";
import config from "../../store/sqftConfig";
import DrawImage from "../workspace/textBox/draw/drawImage";
import COLOR_THEMES, {COLOR} from "../../store/colorThemes";
import RenderFigures from "../../helpers/renderFigures";

export const CORE_POINT_LAYOUTS = {
  black: 'black',
  white: 'white',
  green: 'green',
  ear: 'ear',
  resize: 'resize',
}

export default class PointV2 {
  _modelCorePoint;
  id;
  parent;
  design = {
    radius: 12,
    lineWidth: 1,
    layout: CORE_POINT_LAYOUTS.white
  };
  params = {
    priority: EventManager.priorities.POINT,
    movable: false,
    isCentered: false,

    isCenteredByY: false,
    isResizedByPoint: false,
    isScaledByPoint: false,
    isVisibleOnHover: false,
    shouldRotateShape: false,
  };

  constructor(x, y, parent, pointPrams = {}, design = {}) {
    this.params = Object.assign(this.params, pointPrams);
    this.design = Object.assign(this.design, design);
    let mixins = {
      movable : this.params.movable
        ? new Movable(x,
          y,
          this.design.radius,
          this.design.radius,
          this.params.priority,
          this,
          parent,
          this.params.moveCallback,
          this.params.mouseUpCallback,
          this.params.mouseDownCallback
        )
        : null,
    };
    this._modelCorePoint = new ModelCorePoint(x, y, parent, mixins);
    this.parent = parent;
    this.id = uuid.v4();
    this.initEvents();
  }

  get x() {
    return this._modelCorePoint.getPosX();
  }

  get y() {
    return this._modelCorePoint.getPosY();
  }

  set x(value) {
    return this._modelCorePoint.setPosX(value);
  }

  set y(value) {
    return this._modelCorePoint.setPosY(value);
  }

  get modelCorePoint() {
    return this._modelCorePoint;
  }

  set modelCorePoint(value) {
    this._modelCorePoint = value;
  }

  exportData = () => {
    return {
      id: this.id,
      x: this.x,
      y: this.y,
      design: this.design,
      params: this.params,
    }
  }

  importData = (pointData) => {
    this.id = pointData.id;
    this.x = pointData.x;
    this.y = pointData.y;
    this.design = pointData.design;
    this.params = pointData.params;
  }

  getPointField = () => {
    return getPointField(this.modelCorePoint.getPosX(), this.modelCorePoint.getPosY(), this.modelCorePoint.parent);
  }

  getParent = () => {
    return this.parent;
  }

  getPosition = () => {
    return {
      x: this.modelCorePoint.getPosX(),
      y: this.modelCorePoint.getPosY()
    }
  }

  setPosition(value) {
    this.modelCorePoint.setPosX(value.x);
    this.modelCorePoint.setPosY(value.y);
  }

  rotate(origin, angle, isSlabMode) {
    this._modelCorePoint.rotate(origin, angle, isSlabMode);
  }

  initEvents() {
    EventManager.addEvent(
      EventManager.events.MOUSE_MOVE,
      this.onMouseMove.bind(this),
      this,
      this.params.priority
    );
    EventManager.addEvent(
      EventManager.events.MOUSE_DOWN,
      this.onMouseDown.bind(this),
      this,
      this.params.priority
    );
    EventManager.addEvent(
      EventManager.events.MOUSE_UP,
      this.onMouseUp.bind(this),
      this,
      this.params.priority
    );
    EventManager.addEvent(
      EventManager.events.RENDER,
      this.render.bind(this),
      this,
      this.params.priority
    );
  }

  onMouseMove() {
  }

  onMouseUp() {
  }

  onMouseDown() {
  }

  delete() {
    this.deregisterEvents();
  }

  destroy() {
    this.delete();
  }

  deregisterEvents = () => {
    EventManager.removeEvent(this.modelCorePoint.mixins.movable);
    EventManager.removeEvent(this);
  }

  reInitEvents = () => {
    this.initEvents();
    if (this.modelCorePoint.mixins.movable) {
      this.modelCorePoint.mixins.movable.reInitEvents();
    }
  }

  render = (ctx) => {
    if (workspace && workspace.getState().loading) return;

    // display only hovered or when mouse is down
    if (this.params.isVisibleOnHover && !this.isHoveredWithParent() && !this.isMouseDownWithParent()) {
      return
    }

    let pointField = this.getPointField();

    ctx.save();
    ctx.beginPath();

    switch (this.design.layout) {
      case CORE_POINT_LAYOUTS.black: {
        let arcRadius = 0;
        if (this.isHoveredWithParent()) {
          arcRadius = this.design.radius
          ctx.fillStyle = COLOR.blackLight;
        } else {
          arcRadius = this.design.radius / 2
          ctx.fillStyle = COLOR.white;
        }

        ctx.arc(
          pointField.x,
          pointField.y,
          arcRadius,
          0,
          2 * Math.PI,
          false
        );

        ctx.strokeStyle = COLOR_THEMES[config.activeTheme].primary;

        ctx.stroke();
        ctx.fill();
        break;
      }
      case CORE_POINT_LAYOUTS.white: {
        ctx.arc(
          pointField.x,
          pointField.y,
          this.design.radius,
          0,
          Math.PI,
          false
        );

        ctx.strokeStyle = COLOR_THEMES[config.activeTheme].primary;
        ctx.fillStyle = '#ffffff';
        ctx.stroke();
        ctx.fill();
        break;
      }
      case CORE_POINT_LAYOUTS.green: {
        let arcRadius = 0;
        if (this.modelCorePoint.mixins.movable
          && this.modelCorePoint.mixins.movable.state.hovering
        ) {
          arcRadius = this.design.radius + 5;
          ctx.strokeStyle = COLOR.blackLight;
          ctx.fillStyle = COLOR.blackLight;
        } else {
          arcRadius = this.design.radius;
          ctx.strokeStyle = 'rgba(159,197,34,0.47)';
          ctx.fillStyle = 'rgba(159,197,34, 1)';
        }
        ctx.arc(
          pointField.x,
          pointField.y,
          arcRadius,
          0,
          Math.PI * 2,
          false
        );

        ctx.lineWidth = 2;
        ctx.fill();

        // RenderFigures.drawRotatedArrow(ctx,
        //   pointField.x - 20, pointField.y,
        //   pointField.x, pointField.y - 20,
        //   pointField.x - 20, pointField.y - 20,
        //   10
        // )

        ctx.stroke();
        break;
      }
      case CORE_POINT_LAYOUTS.ear: {
        let subLineWidth = 10;
        let subLineHeight = this.design.radius;
        ctx.moveTo(pointField.x, pointField.y - subLineHeight);
        ctx.lineTo(pointField.x + subLineWidth, pointField.y - subLineHeight);
        RenderFigures.renderOval(ctx, this.design.radius * 2 , this.design.radius * 2, pointField.x+ subLineWidth, pointField.y);
        ctx.moveTo(pointField.x + subLineWidth, pointField.y + subLineHeight);
        ctx.lineTo(pointField.x, pointField.y + subLineHeight);

        ctx.strokeStyle = COLOR_THEMES[config.activeTheme].primary;
        ctx.fillStyle = '#ffffff';
        ctx.lineWidth = this.design.lineWidth;
        ctx.stroke();
        //ctx.fill();
        break;
      }
      case CORE_POINT_LAYOUTS.resize: {
        //outside circle
        ctx.arc(
          pointField.x,
          pointField.y,
          this.design.radius,
          0,
          Math.PI * 2,
          false
        );
        ctx.strokeStyle = COLOR_THEMES[config.activeTheme].primary;
        ctx.fillStyle = '#ffffff';
        ctx.lineWidth = this.design.lineWidth + 1;
        ctx.stroke();
        ctx.fill();

        //inside circle
        ctx.beginPath();
        ctx.arc(
          pointField.x,
          pointField.y,
          this.design.radius - 3,
          0,
          Math.PI * 2,
          false
        );

        ctx.fillStyle = COLOR_THEMES[config.activeTheme].primary;
        ctx.lineWidth = this.design.lineWidth + 1;
        ctx.fill();

        // arrows
        DrawImage.renderImage('resizeArrows', ctx,
          pointField.x - this.design.radius / 2 + 1.5,
          pointField.y - this.design.radius / 2 + 1.5,
          2.5,
          2.5,
          true,
          true
        );
        break;
      }
    }

    ctx.closePath();
    ctx.restore();
  };

  isHoveredWithParent() {
    const isParentMovableHovered = this.modelCorePoint.parent.mixin
      ? this.modelCorePoint.parent.mixin.movable.state.hovering
      : false;
    const isParentHovered = this.modelCorePoint.parent && this.modelCorePoint.parent.state
      ? this.modelCorePoint.parent.state.hovering
      : false;
    const isParentChildrenHovered = this.modelCorePoint.parent.mixin
      ? this.modelCorePoint.parent.mixin.movable.state.hoveringWithChildren
      : false;
    const isHovered = this.modelCorePoint.mixins.movable
      ? this.modelCorePoint.mixins.movable.state.hovering
      : false;

    return isParentHovered || isParentMovableHovered || isParentChildrenHovered || isHovered
  }

  isMouseDownWithParent() {
    const isParentMouseDown = this.modelCorePoint.parent.mixin
      ? this.modelCorePoint.parent.mixin.movable.state.mouseDown
      : false;
    const isParentChildrenMouseDown = this.modelCorePoint.parent.mixin
      ? this.modelCorePoint.parent.mixin.movable.state.mouseDownWithChildren
      : false;
    const isMouseDown = this.modelCorePoint.mixins.movable
      ? this.modelCorePoint.mixins.movable.state.mouseDown
      : false;

    return isParentMouseDown || isParentChildrenMouseDown || isMouseDown
  }
}
